/* VitaWalk Vertrauens-System: Lieferdatum aus der Versandrichtlinie ableiten.
   Richtlinie: Lieferung in der Regel 4 bis 7 Werktage ab Bestelleingang.
   Werktage = Mo bis Fr. Feiertage werden bewusst nicht abgezogen, damit die
   angezeigte Spanne nie optimistischer ist als die Richtlinie. */
(function () {
  var TAG = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var MON = ['Jan.', 'Feb.', 'März', 'April', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'];

  function addWorkdays(from, n) {
    var d = new Date(from.getTime());
    var left = n;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) left--;
    }
    return d;
  }

  function fmt(d, withMonth) {
    return TAG[d.getDay()] + ', ' + d.getDate() + '.' + (withMonth ? ' ' + MON[d.getMonth()] : '');
  }

  function render() {
    var slots = document.querySelectorAll('[data-vw-deliv-range]');
    if (!slots.length) return;
    var now = new Date();
    var start = addWorkdays(now, 4);
    var end = addWorkdays(now, 7);
    var sameMonth = start.getMonth() === end.getMonth();
    var txt = 'zwischen ' + fmt(start, !sameMonth) + ' und ' + fmt(end, true);
    for (var i = 0; i < slots.length; i++) slots[i].textContent = txt;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
  // Warenkorb-Schublade rendert ihren Inhalt nach; erneut versuchen.
  document.addEventListener('click', function () { setTimeout(render, 120); }, true);
})();
